import React from 'react'
import {CollaboratorsProvider} from './CollaboratorsContext'
import {ScanResultProvider} from './ScanResultContext'
import {EmailProvider} from './EmailContext'

/**
 * Encapsulates all the root contexts used by the application
 */
export default class ApplicationContext extends React.Component {
  render() {
    return (
      <CollaboratorsProvider>
        <ScanResultProvider>
          <EmailProvider>
            {this.props.children}
          </EmailProvider>
        </ScanResultProvider>
      </CollaboratorsProvider>
    )
  }
}


// WEBPACK FOOTER //
// ./src/context/ApplicationContext.js